<template>
  <div>
    <div class="ww">
      <div class="dbt">
         <h1>{{ $route.meta.title }}</h1>
        <Func></Func>
      </div>
    </div>
    <transition name="slide-left" >
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
import Func from "./Func";

export default {
  name: "Layout",
  components: { Func },
};
</script>
<style scoped>
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

</style>
